const switchContainerTokens = ({ space }) => ({
  sizes: {
    medium: {
      width: '56px',
      height: `${space[6]}px`,
    },
  },
});

export default switchContainerTokens;
